import React, { Component } from "react";
import {
  Navbar,
  Progress,
  Nav,
  Dropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  Container,
  Row,
  Col,
  Card,
  CardImg,
  CardText,
  CardBody,
  CardLink,
  CardTitle,
  CardSubtitle,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  CustomInput,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner
} from "reactstrap";

class AboutModal extends Component {
  render() {
    const { aboutmodal, abouttoggle } = this.props;
    return (
      <Modal
        isOpen={aboutmodal}
        toggle={abouttoggle} /*className={this.props.className}*/
      >
        <ModalHeader toggle={abouttoggle}>ABOUT THIS PROJECT</ModalHeader>
        <ModalBody>
          <p>
            This is an experimental project to explore a creative frontend for
            the Adzuna Job API.
          </p>
          <p>Built using the following technologies:</p>
          <br />
          <ul>
            <li>React</li>
            <li>Bootstrap</li>
            <li>Adzuna Api</li>
          </ul>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={abouttoggle}>
            THANK YOU
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default AboutModal;
